module.exports = __webpack_public_path__ + "img/head-img.c72c8e7b.png";